module.exports = __webpack_public_path__ + "static/media/notificationIcon.20beb673.svg";